import React from 'react';
import {Navigate} from 'react-router-dom';
import {useAuth} from '../../context/AuthContext';

const AdminRoute = ({children}) => {
    const {user, loading} = useAuth();

    if (!user) {
        if (loading) {
            // En cours de chargement de l'authentification
            return <div>Loading...</div>;
        } else {
            // Pas connecté ? Redirection vers Login
            return <Navigate to="/login"/>;
        }
    }

    console.log(user);

    // Connecté ? Mais pas admin ? Redirection vers la page d'accueil
    if (user.role !== 'admin') {
        return <Navigate to="/"/>;
    }

    // Connecté ? On affiche la page demandée (le Dashboard par exemple)
    return children;
};

export default AdminRoute;